// Adapted from case-desk src/app/App.tsx (provider composition, commit 1d18e32), 2026-08-03; P8 adds
// i18n and the router. Authentication is a server-side session of the tenant host (ADR 0040 § 9), so
// there is no client-side auth provider: the workspace route asks the Experience API bootstrap.
import { QueryClientProvider } from '@tanstack/react-query';
import { useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router';

import { queryClient } from '../api/queryClient';
import { UiProvider } from '../components/UiProvider';
import { i18n } from '../i18n/i18n';

import { createAppRouter } from './router';

export function App() {
  const router = useMemo(() => createAppRouter(), []);

  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <UiProvider>
          <RouterProvider router={router} />
        </UiProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
